import { render, staticRenderFns } from "./JobDescription.vue?vue&type=template&id=17515c66&"
import script from "./JobDescription.vue?vue&type=script&lang=ts&"
export * from "./JobDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports